



























import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator'

import { SelectOption } from '../../../../../../../../../logic/types';
import HttpRequestSetting from "../../../../../../../../../shared/components/HttpRequest/HttpRequestSetting.vue";
import RecordFillFields from "../../../../../../../../../shared/components/HttpRequest/RecordFillFields.vue";
import { AvailableBaseTabs } from "../../../../../../../../../shared/components/HttpRequest/types";
import {
  HttpMethodEnum,
  HttpRequest,
  HttpResponseTypeEnum
} from "../../../../../../../../../shared/types/HttpRequest";
import { getPropertyTranslation } from '../../../../../../../../BotProperties/utils';
import { SelectOptionData } from '../../../../../../../../Pi/types';
import CustomEditor from '../../../../../Editor/CustomEditor'
import { HttpRequestNode } from '../../logic/HttpRequestNode'

@Component({
  components: {
    RecordFillFields,
    HttpRequestSetting,
  },
})
export default class HttpRequestSidebar extends Vue {
  @Prop() node!: HttpRequestNode

  @Prop() editor!: CustomEditor

  requestFieldsInput(payload: HttpRequest) {
    this.node.data = Object.assign(this.node.data, payload)
  }

  get propertiesOptions(): Array<SelectOption> {
    return this.node.nodeProps.properties()
      .map(prop => {
        return {
          label: getPropertyTranslation(this.$i18n, prop.name ?? prop.type),
          value: prop.id?.toString()
        }
      })
  }

  get httpMethods(): Array<SelectOptionData> {
    return [
      {
        label:  HttpMethodEnum.Get,
        value:  HttpMethodEnum.Get,
      },
      {
        label:  HttpMethodEnum.Post,
        value:  HttpMethodEnum.Post,
      },
      {
        label:  HttpMethodEnum.Put,
        value:  HttpMethodEnum.Put,
      },
      {
        label:  HttpMethodEnum.Delete,
        value:  HttpMethodEnum.Delete,
      }
    ]
  }

  get requestFormatOptions(): Array<SelectOption> {
    return [
      {
        label: 'Json',
        value: 'json'
      },
      {
        label: 'Form',
        value: 'form'
      },
      {
        label: 'Xml',
        value: 'xml'
      },
      {
        label: 'Plain',
        value: 'plain'
      },
    ]
  }

  get responseTypeOptions(): Array<SelectOption> {
    return [
      {
        label: this.$t('http_request_response_type_empty').toString(),
        value: "Empty"
      },
      {
        label: "JSON",
        value: "Json"
      },
      {
        label: "XML",
        value: "Xml"
      },
    ]
  }

  get tabs(): Array<SelectOptionData> {
    return [
      {
        label: this.$t('http_request_tab_headers').toString(),
        value: AvailableBaseTabs.headers,
        helpMessage: this.$t('http_request_tab_headers_help_message').toString()
      },
      {
        label: this.$t('http_request_tab_body').toString(),
        value: AvailableBaseTabs.body,
        helpMessage: this.$t('http_request_tab_body_help_message').toString()
      },
      ...this.node.data.response_type !== HttpResponseTypeEnum.Empty ? [ {
        label: this.$t('http_request_tab_mapper').toString(),
        value: 'mapper',
        helpMessage: this.$t('http_request_tab_mapper_help_message').toString()
      } ] : [],
    ]
  }
}
